import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ETICHETE_PERSONAL = {
  Permis_Auto: '🪪 Permis Auto',
  Vizita_Medicala: '🩺 Viz. Medicală',
  ADR: '☢️ ADR',
  CPC: '📜 Atestat CPC',
  Tahograf: '💳 Tahograf',
};

function AlertRow({ label, color, items, cols }) {
  if (!items || items.length === 0) return null;
  return (
    <div style={{marginBottom:16}}>
      <div style={{fontWeight:'bold',color,marginBottom:6,fontSize:13}}>{label} ({items.length})</div>
      <div style={{overflowX:'auto'}}>
        <table style={{width:'100%',fontSize:12}}>
          <thead>
            <tr style={{background:'#f0f4fa'}}>
              {cols.map(c => <th key={c.key} style={{padding:'5px 8px',textAlign:'left'}}>{c.label}</th>)}
              <th style={{padding:'5px 8px',textAlign:'left'}}>Zile rămase</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r,i) => (
              <tr key={i} style={{background: parseInt(r.zileRamase) < 0 ? '#fde8e8' : '#fff3cd'}}>
                {cols.map(c => <td key={c.key} style={{padding:'4px 8px'}}>{r[c.key]}</td>)}
                <td style={{padding:'4px 8px',fontWeight:'bold',
                  color: parseInt(r.zileRamase) < 0 ? '#c0392b' : '#856404'}}>
                  {parseInt(r.zileRamase) < 0
                    ? `Expirat de ${Math.abs(parseInt(r.zileRamase))} zile`
                    : `${r.zileRamase} zile`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function DashboardAlerts() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/api/dashboard')
      .then(r => { setData(r.data); setError(null); })
      .catch(e => setError('Nu s-au putut încărca alertele: ' + (e.response?.data?.error || e.message)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:20,color:'#888'}}>Se încarcă alertele...</div>;
  if (error) return <div style={{padding:20,color:'#c0392b'}}>{error}</div>;
  if (!data) return null;

  const asigurari = data.asigurariExpira || [];
  const autorizari = data.autorizariExpira || [];
  const revizii = data.reviziiExpira || [];
  const personal = (data.personalExpira || []).map(r => ({ ...r, categorieAfisata: ETICHETE_PERSONAL[r.categorie] || r.categorie }));
  const total = asigurari.length + autorizari.length + revizii.length + personal.length;

  if (total === 0) return (
    <div style={{background:'#e8f8ee',borderRadius:8,padding:'16px 20px',fontSize:13,color:'#1a7a3a',fontWeight:'bold'}}>
      ✅ Toate documentele sunt în regulă! Nicio expirare în următoarele 60 de zile.
    </div>
  );

  return (
    <div>
      <div style={{fontWeight:'bold',color:'#c0392b',marginBottom:16,fontSize:14}}>
        ⚠️ {total} documente expirate sau care expiră în 60 de zile
      </div>

      {/* Carduri sumar */}
      <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:20}}>
        {asigurari.length > 0 && (
          <div style={{background:'#e74c3c',borderRadius:8,padding:'10px 16px',flex:1,minWidth:140}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.8)'}}>Asigurări</div>
            <div style={{fontSize:24,fontWeight:'bold',color:'white'}}>{asigurari.length}</div>
          </div>
        )}
        {autorizari.length > 0 && (
          <div style={{background:'#e67e22',borderRadius:8,padding:'10px 16px',flex:1,minWidth:140}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.8)'}}>Autorizări/ITP</div>
            <div style={{fontSize:24,fontWeight:'bold',color:'white'}}>{autorizari.length}</div>
          </div>
        )}
        {revizii.length > 0 && (
          <div style={{background:'#f39c12',borderRadius:8,padding:'10px 16px',flex:1,minWidth:140}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.8)'}}>Revizii</div>
            <div style={{fontSize:24,fontWeight:'bold',color:'white'}}>{revizii.length}</div>
          </div>
        )}
        {personal.length > 0 && (
          <div style={{background:'#8e44ad',borderRadius:8,padding:'10px 16px',flex:1,minWidth:140}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.8)'}}>Personal</div>
            <div style={{fontSize:24,fontWeight:'bold',color:'white'}}>{personal.length}</div>
          </div>
        )}
      </div>

      {/* Detalii */}
      <AlertRow label="🛡️ Asigurări" color="#c0392b" items={asigurari}
        cols={[{key:'nrInmatriculare',label:'Nr. Auto'},{key:'tipDocument',label:'Tip'},{key:'dataExpirare',label:'Expiră'}]}/>
      <AlertRow label="📋 Autorizări / ITP" color="#e67e22" items={autorizari}
        cols={[{key:'nrInmatriculare',label:'Nr. Auto'},{key:'tipAutorizatie',label:'Tip'},{key:'dataExpirariiAutorizarii',label:'Expiră'}]}/>
      <AlertRow label="🔩 Revizii" color="#856404" items={revizii}
        cols={[{key:'nrAuto',label:'Nr. Auto'},{key:'document',label:'Document'},{key:'dataExpirarii',label:'Expiră'}]}/>
      <AlertRow label="🧑‍✈️ Personal" color="#8e44ad" items={personal}
        cols={[{key:'username',label:'Șofer'},{key:'categorieAfisata',label:'Document'},{key:'nrDocument',label:'Nr.'},{key:'dataExpirare',label:'Expiră'}]}/>
    </div>
  );
}
